import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";

import { Provider } from "react-redux";
import { ConfigProvider } from "./contexts/ConfigContext";

import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

import { ToastProvider } from "react-toast-notifications";
import CustomToast from "./hooks/useCustomToast";

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider>
      <ToastProvider
        autoDismiss={true}
        placement="top-right"
        components={{
          // ToastContainer: ({ children }) => (
          //   <div className="toast-component">{children}</div>
          // ),
          Toast: CustomToast,
        }}
      >
        <App />
      </ToastProvider>
    </ConfigProvider>
  </Provider>,
  document.getElementById("root"),
);

reportWebVitals();
